import { Answer, Question } from '../types/domain';

export const LONG_ANSWER_MIN_CHARS = 30;
export const REQUIRED_LONG_ANSWERS = 2;

export function stripHtml(value: string): string {
  return value.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
}

export function isMeaningfulLongAnswer(value: unknown, minimumCharacters = LONG_ANSWER_MIN_CHARS): boolean {
  return typeof value === 'string' && stripHtml(value).length >= minimumCharacters;
}

export function countMeaningfulLongAnswers(questions: Question[], answers: Record<string, Answer>, minimumCharacters = LONG_ANSWER_MIN_CHARS): number {
  return questions
    .filter((question) => question.type === 'long_answer')
    .filter((question) => isMeaningfulLongAnswer(answers[question.id]?.value, minimumCharacters)).length;
}

export function validateExamSubmission(questions: Question[], answers: Record<string, Answer>) {
  const attempted = countMeaningfulLongAnswers(questions, answers);
  return {
    attempted,
    required: REQUIRED_LONG_ANSWERS,
    valid: attempted >= REQUIRED_LONG_ANSWERS,
    message:
      attempted >= REQUIRED_LONG_ANSWERS
        ? ''
        : `Long Answers Attempted: ${attempted} of ${REQUIRED_LONG_ANSWERS} required. Please write at least ${LONG_ANSWER_MIN_CHARS} meaningful characters in any ${REQUIRED_LONG_ANSWERS} long-answer responses.`
  };
}
